import React from 'react';
import '../styles/InfoModal.css';

function InfoModal({ items }) {
  return (
    <div className="info-modal">
      {items.map((item, index) => (
        <div className="info-item" key={index}>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
          {index < items.length - 1 && <div className="vertical-line"></div>}
        </div>
      ))}
    </div>
  );
}

export default InfoModal;